import React from "react";
import { Us, Story, Media, Values } from "../../components/About";
import { BlogLayout } from "../../containers";

function About() {
  return (
    <BlogLayout>
      <Us />
      <Story />
      {/* <Values /> */}
      {/* <Media/> */}
    </BlogLayout>
  );
}

export default About;
